// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.css";
	// return url for filenames based on template
	return "" + ({"5":"QRCode","53":"ShareProduct","251":"checkout","561":"Dashboard","849":"AddProduct"}[chunkId] || chunkId) + ".css";
};